<template>
    <div>
        <div class="left-toolbar mb10">
            <button @click="exportPdf" class="swb-btn-small swb-btn">导出pdf</button>
        </div>
        <swb-shop-device-stcok-check-voucher-finish-for-pdf :voucherId="voucherId" :assetType="assetType" ref="swb_shop_device_stcok_check_voucher_finish_for_pdf"></swb-shop-device-stcok-check-voucher-finish-for-pdf>
    </div>

</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import SwbShopDeviceStockCheckVoucherFinishedForPdf from './ShopDeviceStockCheckVoucherFinishedForPdf';
    Vue.regist(SwbShopDeviceStockCheckVoucherFinishedForPdf);
    //
    import { showHtmlToPdfDlg } from '../ctrl/dialog'
    export default {
        name: 'swb-shop-device-stcok-check-voucher-finished-pdf',
        desc: '调拨单导出',
        props: {
            voucherId: {
                type: Number,
                deafult: null,
            },
            assetType: {
                type: Number,
                deafult: null,
            },
        },
        data: function () {
            return {
            }

        },
        created: function () {
        },
        methods: {
            exportPdf: function () {
                let self = this;
                let result = self.$refs.swb_shop_device_stcok_check_voucher_finish_for_pdf.getHtml() || '';
                console.log(result);
                showHtmlToPdfDlg("盘点单处理-业务单据", result, null);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceStockCheckVoucherFinishedPdf.vue